import React from 'react';

import * as S from './styles';

const Gallery06: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Caption className="mobile">
          <p>
            Look de alfaiataria da coleção de verão 2023 de Thom Browne recupera
            debruns na lapela e composição de bermuda com paletó. | Foto: Getty
            Images
          </p>
        </S.Caption>
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
        <S.Caption className="mobile">
          <p>
            A ideia ganhou força quando o Príncipe de Gales apareceu com o
            conjunto, que passou a ser usado por estudantes universitários nos
            anos 1920. Foto: reprodução do livro “100 anos de moda masculina”.
          </p>
        </S.Caption>
      </S.Wrapper>
      <S.Caption className="desktop">
        <p>
          Look de alfaiataria da coleção de verão 2023 de Thom Browne recupera
          debruns na lapela e composição de bermuda com paletó (à esq.). A ideia
          ganhou força quando o Príncipe de Gales apareceu com o conjunto, que
          passou a ser usado por estudantes universitários nos anos 1920 (à
          dir.). Getty Images e reprodução do livro “100 anos de moda
          masculina”.
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery06;
